/** @format */

import React from "react";
import { Link } from "react-scroll";
import background from "../assets/background.png"; // Assurez-vous que l'image existe à ce chemin
import logo from "../assets/logo.svg";

export default function HomeSection() {
  return (
    <div className="relative overflow-hidden">
      {/* Conteneur pour l'effet parallax */}
      <div
        className="absolute inset-0 bg-cover bg-center sm:bg-fixed"
        style={{
          backgroundImage: `url(${background})`,
          backgroundRepeat: "repeat",
          backgroundSize: "cover",
        }}
      />
      <section
        id="home"
        className="flex justify-center items-center min-h-screen flex-col gap-4 sm:gap-6 lg:gap-8 text-white relative z-10"
      >
        <img src={logo} alt="logo" className="w-8/12 sm:w-6/12 lg:w-5/12" />

        <h1 className="text-lg sm:text-xl lg:text-2xl text-center px-4 sm:px-0">
          Le logiciel de gestion de planning pour petites entreprises
        </h1>

        <p className="text-center text-sm sm:text-base lg:text-lg px-4 sm:px-0">
          Gérez votre planning en toute simplicité
        </p>

        <div className="absolute bottom-2 left-2 text-xs sm:text-sm text-white">
          <p>By Terrettaz Informatique SA</p>
        </div>

        <Link
          to="presentation"
          smooth={true}
          duration={500}
          className="cursor-pointer bg-white text-green-900 px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg hover:bg-green-900 hover:text-white transition duration-150 ease-in-out"
        >
          En savoir plus
        </Link>
      </section>
    </div>
  );
}
